import gql from 'graphql-tag';

export const loginMutation = gql`
  mutation login($input: AuthInput!) {
    login(input: $input) {
      status
      token
      redirect
      state
    }
  }
`;
